import(/* webpackMode: "eager", webpackExports: ["DesignListener"] */ "/app/apps/ui/components/company/design.listener.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LegacyBrowserWarning"] */ "/app/apps/ui/components/legacy.browser.warning.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/ui/components/logo/tucan.png");
;
import(/* webpackMode: "eager", webpackExports: ["Maintenance"] */ "/app/apps/ui/components/maintenance.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VersionCheck"] */ "/app/apps/ui/components/version.check.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/ui/css/global.scss");
;
import(/* webpackMode: "eager", webpackExports: ["AntdProvider"] */ "/app/apps/ui/src/app/[lang]/antd.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApolloProvider"] */ "/app/apps/ui/src/app/[lang]/apollo.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EnvProviderClient"] */ "/app/apps/ui/src/app/[lang]/env.provider.client.ts");
;
import(/* webpackMode: "eager", webpackExports: ["EnvironmentInfo"] */ "/app/apps/ui/src/app/[lang]/environment.info.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PhProvider"] */ "/app/apps/ui/src/app/[lang]/ph.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoreProvider"] */ "/app/apps/ui/src/app/[lang]/store.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StyledComponentsProvider"] */ "/app/apps/ui/src/app/[lang]/styled.components.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nWarmer"] */ "/app/apps/ui/src/i18n/i18n.warmer.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/antd/dist/reset.css");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/app/[lang]/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../../../public/fonts/basiercircle-regular-webfont.woff2\",\"style\":\"normal\",\"weight\":\"normal\"},{\"path\":\"../../../public/fonts/basiercircle-bold-webfont.woff2\",\"style\":\"normal\",\"weight\":\"bold\"},{\"path\":\"../../../public/fonts/basiercircle-semibold-webfont.woff2\",\"style\":\"normal\",\"weight\":\"600\"}]}],\"variableName\":\"basiercircle\"}");
